module.exports = __webpack_public_path__ + "b0c993da0fb3c5843844e6f7a42314bd.svg";